import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

type ComponentType = "ACTIVE_VOUCHERS" | "ONGOING_ACTIVITIES" | "TRANSACTIONS" | "CAMPAIGN"

@Component({
    selector: 'wallet-list-error',
    imports: [TranslateModule],
    templateUrl: './wallet-list-error.component.html',
    styleUrl: './wallet-list-error.component.scss'
})
export class WalletListErrorComponent {

  public readonly componentType = input.required<ComponentType>();

}
